import { server_connection } from 'config';

export const GET_ASSET_LIST             = '[ASSET APP] GET ASSET LIST';
export const GET_MODEL_ASSET_LIST       = '[ASSET APP] GET MODEL ASSET LIST';
export const GET_MODEL_FILE_LIST        = '[ASSET APP] GET MODEL FILE LIST';
export const UPLOAD_ASSET_WITH_RELATION = '[ASSET APP] UPLOAD ASSET WITH RELATION';
export const GET_ASSET_BY_ID            = '[ASSET APP] GET ASSET BY ID';
export const GET_VIDEO_PROGRESS         = '[ASSET APP] GET VIDEO PROGRESS';
export const RESET_VIDEO_PROGRESS       = '[ASSET APP] RESET VIDEO PROGRESS';

export function getAssetList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/asset/list')
            .then((response) => response.json())
            .then((assetList) => {
                dispatch({
                    type: GET_ASSET_LIST,
                    payload: assetList,
                });
            });
    }
}

export function getModelAssetList(model_type, model_id, storage_type = 'asset') {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/asset/model-asset/' + model_type + '/' + model_id)
            .then((response) => response.json())
            .then((assetList) => {
                if (storage_type === 'asset') {
                    dispatch({
                        type: GET_MODEL_ASSET_LIST,
                        payload: assetList
                    });
                } else {
                    dispatch({
                        type: GET_MODEL_FILE_LIST,
                        payload: assetList
                    });
                }
            });
    }
}

export function uploadAssetWithRelation(formData, model_type, model_id, callBackFunction = () => { }) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/asset/upload/relation',
            {
                method: 'POST',
                body: formData
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (model_type === 'instructor_qualification') {
                    return callBackFunction(responseData)
                }
                else if (model_type === 'assignment') {
                    callBackFunction(model_id, responseData)
                }
                else if (model_type === 'major') {
                    callBackFunction(model_id, responseData)
                }
                else if (model_type === 'module') {
                    callBackFunction(model_id, responseData)
                }
                else if (model_type === 'lesson') {
                    callBackFunction(model_id, responseData)
                }
                else {
                    callBackFunction(model_id)
                }
            });
    }
}

export function uploadAssetNoRelation(formData, model_type='', model_id=0, callBackFunction = () => { }) {
    return async (dispatch, getState) => {
        fetch(server_connection + '/asset/upload',
            {
                method: 'POST',
                body: formData
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (model_type === 'question') {
                    if(responseData.length > 0) {
                        callBackFunction(model_id, responseData[0]);
                    }
                } else {
                    callBackFunction(responseData)
                }
            });
    }
}

export function deleteAsset(asset_id, model_type='', model_id=0, callBackFunction = () => { }) {
    return (dispatch, getState) => {
        fetch(server_connection + '/asset/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    asset_id: asset_id,
                    model_type,
                    model_id
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                // console.log('callBackFunction', model_id);
                callBackFunction(model_id);
            });
    }
}

export function getAssetById(asset_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/asset/' + asset_id)
            .then((response) => response.json())
            .then((asset) => {
                dispatch({
                    type: GET_ASSET_BY_ID,
                    payload: asset
                });
            });
    }
}

export function createVideoProgress(asset_id, auth_id, played_seconds, completed) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/asset/video_progress',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    asset_id: asset_id,
                    auth_id: auth_id,
                    played_seconds: played_seconds,
                    completed: completed
                })
            })
            .then((response) => response.json())
            .then((responseData) => {

            });

    }
}

export function saveAssetName(asset, callBackFunction = () => { }) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/asset/save_name',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    asset
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                callBackFunction()
            });

    }
}

export function getVideoProgress(asset_id, auth_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/asset/video_progress/' + asset_id + '/' + auth_id)
            .then((response) => response.json())
            .then((video_progress) => {
                dispatch({
                    type: GET_VIDEO_PROGRESS,
                    payload: video_progress
                });
            });
    }
}

export function resetVideoProgress(progress) {
    return {
        type: RESET_VIDEO_PROGRESS,
        payload: progress
    }
}





// WEBPACK FOOTER //
// src/main/content/asset/store/actions/asset.actions.js